import React from 'react';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import yellowAlert from "src/assets/images/yellow-alert.png";

const ShowAlert = ({ onlyShowMessage = null, doNotShow = null }) => {
    const [{ system_alert_list }, { remove_system_alert_indicator }, { }] = useDOMAttachToSystemStore();

    const ErrorMessageUI = (v, i) => {
        const isDisplay = v[1]?.isDisplay !== undefined ? v[1]?.isDisplay : true
        const isDisplayIcon = v[1]?.isDisplayIcon !== undefined ? v[1]?.isDisplayIcon : false

        return (
            <div className="row" key={v[1].name}>
                <div className="col-lg-12 p-0 mb-2">
                    <div className={'alert mb-0 alert-' + v[1].type} role="alert">
                        <div className='d-flex flex-column w-100'>
                            <div className='d-flex justify-content-between'>
                                <span><div dangerouslySetInnerHTML={{ __html: v[1].message }} /></span>

                                {isDisplay &&
                                    <button type="button" className="close" data-dismiss={"alert" + i} aria-label="Close" onClick={() =>
                                        remove_system_alert_indicator(v[1].name)
                                    }>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                }
                                {isDisplayIcon &&
                                    <img className="ms-auto" src={yellowAlert} />
                                }
                            </div>
                            {v[1].data && (
                                <div className='mt-2'>
                                    <span><strong>Restricted Items:</strong> </span>
                                    <div className='text-blue'><strong> {v[1].data?.join(', ')}</strong></div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <>
            <div autoFocus={true} className="container">
                {/* onlyShowMessage used for displaying only some particular alerts   */}
                {/* doNotShow used for not displaying some particular alerts */}
                {onlyShowMessage?.length > 0 ? (
                    Object.entries(system_alert_list).map((obj, i) => {
                        if (onlyShowMessage.includes(obj[0])) {
                            return ErrorMessageUI(obj, i);
                        }
                        return null;
                    })
                ) : doNotShow?.length > 0 ? (
                    Object.entries(system_alert_list).map((obj, i) => {
                        if (!doNotShow.includes(obj[0])) {
                            return ErrorMessageUI(obj, i);
                        }
                        return null;
                    })
                ) : (
                    Object.entries(system_alert_list).map((v, i) => ErrorMessageUI(v, i))
                )

                }
            </div>
        </>
    )
}

export default ShowAlert